import axios from 'axios'

export const state = {
  userNotifications: [],
}

export const getters = {}

export const mutations = {
  SET_ALL(state, payload) {
    state.userNotifications = payload
  },
  ADD(state, payload) {
    state.userNotifications = [payload, ...state.userNotifications]
  },
  DELETE(state, itemId) {
    const index = state.userNotifications.findIndex(x => x.id === itemId)
    if (index !== -1) {
      state.userNotifications.splice(index, 1)
    }
  },
  UPDATE(state, notification) {
    let newArray = [...state.userNotifications]
    var index = newArray.findIndex(x => x.id === notification.id)
    newArray[index] = notification
    state.userNotifications = newArray
  },
}

export const actions = {
  fetch({ commit, dispatch }) {
    axios.get(`/api/1/notifications`, {}).then(response => {
      commit('SET_ALL', response.data.content)
    })
  },
  markRead({ commit }, notificationId) {
    axios.put(`/api/1/notifications/${notificationId}`).then(response => {
      commit('UPDATE', response.data)
    })
  },
  markReadAll({ commit, dispatch }) {
    this.state.userNotifications.userNotifications.forEach(item =>
      dispatch('markRead', item.id)
    )
  },
}
